import React, { useContext, useMemo } from "react";
import style from "./index.module.scss";
import {
    Alert,
    Collapse,
    Empty,
    Icon,
    Spin,
    Statistic,
    Card,
    Row,
    Col
} from "antd";
import ScorePanel from "./Components/ScorePanel";
import Average from "./Components/Average";
import PanelText from "./Components/PanelText";
import ScoreCardFooter from "../Components/ScoreCardFooter";
import { ScoreContext } from "../Components/CourseScoreProvider/context";
import { ActivityType, queryRule, QueryRuleResult } from "API/scoreRule";
import useRequest from "Utils/useRequest";
import { Link, useLocation } from "react-router-dom";
import Title from "./Components/Title";
import qs from "qs";
import useDeviceType from "Utils/useDeviceType";
import { isTrue } from "../../../Utils/filter";
import { getScoreList } from "../../../API/scoreRule";
import CustomEmpty from "../Components/CustomEmpty";
import Help from "./Components/Help";
import TableHeadTip from "../Components/TableHeadTip";

export default function CourseScore() {
    const { isPC } = useDeviceType();
    const location = useLocation();
    const { courseNo, courseSeq, weekTimeId } = useContext(ScoreContext);

    const [scoreInfo] = useRequest<QueryRuleResult>(
        () => queryRule({ courseNo, courseSeq }),
        { silence: true },
        [courseNo, courseSeq]
    );

    //成绩明细
    const [data, { loading }] = useRequest(
        () => getScoreList(courseNo, courseSeq),
        {},
        [courseNo, courseSeq]
    );

    const { courseName } = useMemo(
        () => qs.parse(location.search, { ignoreQueryPrefix: true }) as any,
        [location.search]
    );

    return (
        <div className={`${isPC ? style.cardPc : style.cardM}`}>
            {!isPC && (
                <>
                    <p className={style.titleName}>
                        {courseName}
                        <Link
                            className={style.skipRule}
                            to={`/course/score/rules/${courseNo}/${courseSeq}/${weekTimeId}?courseName=${courseName}`}>
                            成绩规则
                        </Link>
                    </p>
                    <div>
                        {isTrue(scoreInfo?.isProcess) && (
                            <div className={style.subTitle}>过程化考核</div>
                        )}
                    </div>
                </>
            )}

            {/*暂时不做*/}
            {/*{!isPC && (*/}
            {/*    <div className={style.weightWrapper}>*/}
            {/*        <Title title="成绩权重" />*/}
            {/*        <Collapse*/}
            {/*            expandIcon={({ isActive }) => (*/}
            {/*                <Icon*/}
            {/*                    type="caret-right"*/}
            {/*                    rotate={isActive ? 90 : 0}*/}
            {/*                />*/}
            {/*            )}>*/}
            {/*            <Panel header="点此查看" key="1">*/}
            {/*                <ScoreProportion />*/}
            {/*            </Panel>*/}
            {/*        </Collapse>*/}
            {/*    </div>*/}
            {/*)}*/}

            <Spin spinning={loading}>
                {!data && (
                    <CustomEmpty
                        style={{ margin: "220px auto" }}
                        image="default"
                        description="任课教师暂未发布成绩，请耐心等待">
                        <div className={style.description}>
                            <span className={style.descText}>
                                更多成绩信息，请点击
                            </span>
                            <Link
                                to={`/course/detail/${courseNo}/${courseSeq}/${weekTimeId}/report`}
                                className={style.toLink}>
                                学习报告
                            </Link>
                        </div>
                    </CustomEmpty>
                )}

                {!!data && (
                    <>
                        <Alert
                            message="白果云平台仅展示过程化考核成绩，最终成绩以教务处发布成绩为准。"
                            style={{ marginBottom: 15 }}
                        />
                        <div className={style.flex}>
                            <Help />
                        </div>
                        {/*<General data={data} />*/}
                        <Title title="成绩明细">
                            <span className={style.tips}>
                                小数位的处理规则：
                                模块成绩保留一位小数，四舍五入
                            </span>
                        </Title>
                        {data?.gradeArray.map(gradeArray => (
                            <div key={gradeArray.id}>
                                <Average
                                    title={gradeArray.name}
                                    totalScore={gradeArray?.score}
                                    grade={gradeArray?.grade}
                                />

                                {gradeArray?.child
                                    .filter(item => item.grade !== "0")
                                    .map(item => {
                                        return (
                                            <Collapse
                                                key={item.id}
                                                accordion
                                                expandIconPosition="right"
                                                expandIcon={({ isActive }) => (
                                                    <Icon
                                                        type="caret-right"
                                                        rotate={
                                                            isActive ? 90 : 0
                                                        }
                                                    />
                                                )}
                                                bordered={false}>
                                                <Collapse.Panel
                                                    disabled={
                                                        item.activityType ===
                                                        ActivityType.custom
                                                    }
                                                    showArrow={
                                                        item.activityType !==
                                                        ActivityType.custom
                                                    }
                                                    header={
                                                        <ScorePanel
                                                            title={
                                                                gradeArray.name
                                                            }
                                                            data={item}
                                                        />
                                                    }
                                                    key={item.id}>
                                                    {item.child.map(el => (
                                                        <PanelText
                                                            data={el}
                                                            key={el.id}
                                                            courseNo={courseNo}
                                                            courseSeq={
                                                                courseSeq
                                                            }
                                                            weekTimeId={
                                                                weekTimeId
                                                            }
                                                        />
                                                    ))}
                                                    {item.child.length ===
                                                        0 && (
                                                        <CustomEmpty image="default" />
                                                    )}
                                                </Collapse.Panel>
                                            </Collapse>
                                        );
                                    })}
                            </div>
                        ))}

                        <div className={style.table}>
                            <TableHeadTip title="额外加分" />
                            <div style={{ padding: "35px" }}>
                                {!scoreInfo?.extraRule && (
                                    <Empty description="此课程未设置额外加分" />
                                )}
                                <Row gutter={15}>
                                    {scoreInfo?.extraRule &&
                                        data?.extraGrade.map(item => (
                                            <Col
                                                xs={12}
                                                span={4}
                                                key={item.extraName}>
                                                <Card>
                                                    <Statistic
                                                        title={item.extraName}
                                                        value={item.score}
                                                        suffix="分"
                                                    />
                                                </Card>
                                            </Col>
                                        ))}
                                </Row>
                            </div>
                        </div>

                        <ScoreCardFooter />
                    </>
                )}
            </Spin>
        </div>
    );
}
